import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-d_zuo_s",
  "use": "icon-d_zuo_s-usage",
  "viewBox": "0 0 12 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 12 16\" id=\"icon-d_zuo_s\"><defs><style>#icon-d_zuo_s .a{fill:#fff;stroke:#707070;}#icon-d_zuo_s .b{clip-path:url(#icon-d_zuo_s_a);}#icon-d_zuo_s .c{fill:none;stroke:rgba(0,0,0,0.24);stroke-linecap:round;stroke-linejoin:round;}</style><clipPath id=\"icon-d_zuo_s_a\"><rect class=\"a\" width=\"12\" height=\"16\" /></clipPath></defs><g class=\"b\"><path class=\"c\" d=\"M9.407,2458l-6,6,6,6\" transform=\"translate(-0.407 -2455.496)\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol